import { IJsonQuery, IJsonQueryType, ECategoryType, ERentTime } from '../../repositories/common/json_query';
import * as R from 'ramda';

import { FDealType, offerTypeFromJsonQuery, FOfferType } from '../../utils/category';
import { setRootType, setTerm, setTerms } from './helpers';
import { selectOfferType } from './selectOfferType';

const FDealTypeName = new Map<FDealType, string>([
  [FDealType.Sale, 'sale'],
  [FDealType.RentDaily, 'rent'],
  [FDealType.RentLongterm, 'rent'],
]);

const FCategoryMap = new Map<FDealType, ECategoryType>([
  [FDealType.RentLongterm, ECategoryType.CommercialLandRent],
  [FDealType.Sale, ECategoryType.CommercialLandSale],
]);

export function setDealType(jsonQuery: IJsonQuery) {
  return (nextDealType: FDealType): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    const type = nextJsonQuery._type;
    const category = nextJsonQuery.category;

    let nextType: IJsonQueryType = 'flatrent';

    const nextDealTypeString = FDealTypeName.get(nextDealType);
    if (nextDealTypeString) {
      nextType = type.replace(/rent|sale/, nextDealTypeString) as IJsonQueryType;
    }

    if (nextDealType !== FDealType.RentDaily) {
      if (category) {
        nextJsonQuery = setTerms('category')(nextJsonQuery)([FCategoryMap.get(nextDealType) as ECategoryType]);
      }
      nextJsonQuery = setTerm('for_day')(nextJsonQuery)(ERentTime.NotDaily);
    } else {
      nextJsonQuery = setTerm('category')(nextJsonQuery)(undefined);
      nextJsonQuery = setTerm('for_day')(nextJsonQuery)(ERentTime.Daily);
    }

    nextJsonQuery = setRootType(nextType)(nextJsonQuery);

    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const nextOfferType = resetNextOfferType(nextDealType, offerType);
    if (nextOfferType) {
      nextJsonQuery = selectOfferType(nextJsonQuery)(nextOfferType);
    }

    return nextJsonQuery;
  };
}

function resetNextOfferType(dealType: FDealType, offerType: FOfferType) {
  switch (dealType) {
    case FDealType.RentLongterm:
      if (offerType & (FOfferType.FlatNew | FOfferType.FlatShared)) {
        return FOfferType.FlatOld;
      }
      break;
    case FDealType.RentDaily:
      if (offerType & (FOfferType.Any & ~FOfferType.FlatOld & ~FOfferType.Room & ~FOfferType.Bed & ~FOfferType.House)) {
        return FOfferType.FlatOld;
      }
      break;
    case FDealType.Sale:
      if (offerType & (FOfferType.FlatOld | FOfferType.Bed)) {
        return FOfferType.Flat;
      }
      break;
    default:
      return null;
  }

  return null;
}
